import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { DRC_XML_URL, ISTATACARD, DCR_TATACARD_URL, DCR_SBICARD_URL,ALL_CARD_JSON_DCR_XML } from '../config/app-settings.config';
import { tap } from 'rxjs/operators';
import { ThemeService } from './theme.service';
const iw: any = window['iw'];
@Injectable({
  providedIn: 'root'
})
export class IwService {

  private applicationStatusData;
  private salutationDropdownDcr;
  private eapplyFormLabelsDcr;
  private eapplyNationalityDCR;
  private eapplyOccupationDCR;
  private eapplyDCOccupationDCR;
  private eapplyAgeMappingDCR;
  private eapplyCardUpgradeMappingDCR;
  private eapplySubmissionVerbiageDCR;
  private eapplyQualificationDCR;
  private eapplyResidentialDCR;
  private eapplyMailingAddressDCR;
  private eapplyFormPostQDEDCR;
  private eapplyBancaSavingAccountDCR;
  private eapplyBancaCarLoanDCR;
  private eapplyBancaHousingLoanDCR;
  private eapplyBancaDefaultConfigurationDCR;
  //private eapplyTrackVerbiageDCR;
  private addOnRelationshipDCR;
  private addOnGenderDCR;
  private partnerCardDetails;
  private cardTypeAddOnMappingDCR;
  private detailApplicationStatusDCR;

  
  TATACARD = ISTATACARD;
  cardXmlData: any;
  themeParam: any;
  partnerCode: any;
  encryptedToken: any = window['authenticationDetails']['EapplyTokenGenerationResponse']['tokenGenerationResponse']['encrypted_token'] || sessionStorage.getItem('encryptedToken');
  tokenVal: any = window['authenticationDetails']['EapplyTokenGenerationResponse']['tokenGenerationResponse']['access_token'] || sessionStorage.getItem('jwt');
  sprintApplicableCardList: any;


  constructor(private http: HttpClient,private themeService: ThemeService) {
    this.detailApplicationStatusDCR = iw.getPropertyValue('applicationStatusDCR')
    this.salutationDropdownDcr = iw.getPropertyValue('eapplySalutationDCR');
    this.eapplyFormLabelsDcr = iw.getPropertyValue('eapplyFormLabelDCR');
    this.eapplyNationalityDCR = iw.getPropertyValue('eapplyNationalityDCR');
    this.eapplyOccupationDCR = iw.getPropertyValue('eapplyOccupationDCR');
    this.eapplyDCOccupationDCR = iw.getPropertyValue('eapplyDCOccupationDCR');
    this.eapplyAgeMappingDCR = iw.getPropertyValue('eapplyAgeMappingDCR');
    this.eapplyCardUpgradeMappingDCR = iw.getPropertyValue('eapplyCardUpgradeMappingDCR');
    this.eapplySubmissionVerbiageDCR = iw.getPropertyValue('eapplyVerbiageDCR');
    this.eapplyQualificationDCR = iw.getPropertyValue('eapplyQualificationDCR');
    this.eapplyResidentialDCR = iw.getPropertyValue('eapplyResidentialDCR');
    this.eapplyMailingAddressDCR = iw.getPropertyValue('eapplyMailingAddressDCR');
    this.eapplyFormPostQDEDCR = iw.getPropertyValue('eapplyFormPostQDEDCR');
    this.eapplyBancaSavingAccountDCR = iw.getPropertyValue('eapplyBancaSavingAccountDCR');
    this.eapplyBancaCarLoanDCR = iw.getPropertyValue('eapplyBancaCarLoanDCR');
    this.eapplyBancaHousingLoanDCR = iw.getPropertyValue('eapplyBancaHousingLoanDCR');
    this.eapplyBancaDefaultConfigurationDCR = iw.getPropertyValue('eapplyBancaDefaultConfigurationDCR');
    // this.eapplyTrackVerbiageDCR = iw.getPropertyValue('eapplyTrackVerbiageDCR');
    this.addOnRelationshipDCR = iw.getPropertyValue('addOnRelationshipDCR');
    this.addOnGenderDCR = iw.getPropertyValue('addOnGenderDCR');
    // this.partnerCardDetails = iw.getPropertyValue('partnerDCRPI');
    this.cardTypeAddOnMappingDCR = iw.getPropertyValue('cardTypeAddOnMappingDCR');
    this.sprintApplicableCardList = iw.getPropertyValue('sprintApplicableCardList');
    this.applicationStatusData = "";

  }

  public getApplicationStatusData(){
    return this.detailApplicationStatusDCR.dcrContent.root;
  }

  public getsprintApplicableCardList() {
    return this.sprintApplicableCardList.dcrContent.root.name_value_pair;
  }
  public getsalutationDropdown() {
    return this.salutationDropdownDcr;
  }
  public geteapplyFormLabelDcr() {
    return this.eapplyFormLabelsDcr;
  }
  public getnationalityDropdown() {
    return this.eapplyNationalityDCR;
  }
  public getoccupationDropdown() {
    return this.eapplyOccupationDCR.dcrContent.root.name_value_pair;
  }
  public getDCoccupationDropdown() {
    return this.eapplyDCOccupationDCR.dcrContent.root.name_value_pair;
  }
  public getAgePolicyForOccupation() {
    return this.eapplyAgeMappingDCR.dcrContent.root;
  }
  public geteapplyCardUpgradeMappingDCR() {
    return this.eapplyCardUpgradeMappingDCR.dcrContent.root.name_value_pair;
  }
  public getPartnerCardDetailsDcr(theme){
    //console.log("DCR is ==>"+`partnerDCRPI_${theme}`);
    this.partnerCardDetails = iw.getPropertyValue('partnerDCRPI');
    // this.partnerCardDetails = iw.getPropertyValue(`partnerDCRPI_${theme}`);
    return this.partnerCardDetails.dcrContent.root;
  }
  public getcardTypeAddOnMappingDCR() {
    return this.cardTypeAddOnMappingDCR.dcrContent.root.name_value_pair;
  }
  public getBancaDefaultConfigurationDCR() {
    return this.eapplyBancaDefaultConfigurationDCR.dcrContent.root.name_value_pair;
  }
  getDcrXmlResponse(queryString, channel) {
    console.log("queryString ======> ", queryString);
    console.log("channel =======>",channel);
    if (queryString && queryString.includes("personal/credit-cards/")) {
      let a = 'personal/credit-cards/'
      queryString= queryString.replace('personal/credit-cards/', '')
    }
    let urlPath: any;
    ISTATACARD ? urlPath = DCR_TATACARD_URL : urlPath = DCR_SBICARD_URL
    const url = channel && channel == '701' ? `${urlPath}${queryString}&CHN=${channel}` : `${urlPath}${queryString}`; // personal/credit-cards/lifestyle/sbi-card-elite.dcr
    console.log("dcr url ========> ", url);
    const headers = new HttpHeaders({
      // 'Content-Type': 'text/plain; charset=utf-8;'
      "Content-Type": "application/json",
      Token: this.encryptedToken || null,
      Authorization: 'Bearer ' + this.tokenVal,
      Channel: 'sbicard',
      withCredentials: 'true'
    });
    console.log("DCR header ======>", headers);
    return this.http.get(url, { headers });

  }

  getDcrXmlCardReponse() {
    let url = ALL_CARD_JSON_DCR_XML;
    // const headers = new HttpHeaders({
    //   //'Content-Type': 'text/plain; charset=utf-8;',
    //   //"Content-Type": "text/xml",
    //   'Accept': 'text/html, application/xhtml+xml, */*',
    // 'Content-Type': 'application/x-www-form-urlencoded',
    //   Token: this.encryptedToken || null,
    //   //Authorization: 'Bearer ' + this.tokenVal,
    //   channel: 'sbicard',
    //   withCredentials: 'true',
      
    // });


    // const  httpOptions = {
    //   headers: new HttpHeaders({
    //     'Accept': 'text/html, application/xhtml+xml, */*',
    //     'Content-Type': 'application/x-www-form-urlencoded',
    //     Token: this.encryptedToken || null,
    //   //Authorization: 'Bearer ' + this.tokenVal,
    //   channel: 'sbicard',
    //   withCredentials: 'true',
    //   }),
    //   responseType: 'text'
    // };

    let headers = new HttpHeaders();
    headers = headers.set('Token', this.encryptedToken || null).set('channel','sbicard'); 
    const requestOptions: any = {
      headers: headers,
      responseType: 'text'
    }
    return this.http.get<string>(url,requestOptions).pipe(
      tap( // Log the result or error
        data => console.log(data),
        error => console.log(error)
      )
      );
  }


  getDcrXmlResponseForPromise(queryString, channel) {
    if (queryString.includes("personal/credit-cards/")) {
      let a = 'personal/credit-cards/'
      queryString= queryString.replace('personal/credit-cards/', '')
    }
    let urlPath: any;
    ISTATACARD ? urlPath = DCR_TATACARD_URL : urlPath = DCR_SBICARD_URL
    const url = channel && channel == '701' ? `${urlPath}${queryString}&CHN=${channel}` : `${urlPath}${queryString}`; // personal/credit-cards/lifestyle/sbi-card-elite.dcr
    const headers = new HttpHeaders({
      // 'Content-Type': 'text/plain; charset=utf-8;',
      "Content-Type": "application/json",
      Token: this.encryptedToken || null,
      Authorization: 'Bearer ' + this.tokenVal,
      Channel: 'sbicard',
      withCredentials: 'true',
    });
    return new Promise((resolve, reject) => {
      this.http.get(url, { headers }).subscribe(data => {
        let res = {};
        res = data;
        resolve(res);
      },
        err => {
          reject(err);
        });
    });
  }
  public geteapplySetailApplicationStatusDCR() {
    //console.log(this.eapplySubmissionVerbiageDCR.dcrContent.root.Response)
    return this.detailApplicationStatusDCR.dcrContent;
  }
  public geteapplySubmissionVerbiageDCR() {
    //console.log(this.eapplySubmissionVerbiageDCR.dcrContent.root.Response)
    return this.eapplySubmissionVerbiageDCR.dcrContent.root.Response;
  }

  public geteapplyQualificationDCR() {
    return this.eapplyQualificationDCR.dcrContent.root.name_value_pair;
  }
  public geteapplyResidentialDCR() {
    return this.eapplyResidentialDCR.dcrContent.root.name_value_pair;
  }
  public geteapplyMailingAddressDCR() {
    return this.eapplyMailingAddressDCR.dcrContent.root.name_value_pair;
  }
  public geteapplyFormPostQDEDCR() {
    return this.eapplyFormPostQDEDCR.dcrContent.root;
  }
  public geteapplyBancaSavingAccountDCR() {
    return this.eapplyBancaSavingAccountDCR.dcrContent.root.name_value_pair;
  }
  public geteapplyBancaCarLoanDCR() {
    return this.eapplyBancaCarLoanDCR.dcrContent.root.name_value_pair;
  }
  public geteapplyBancaHousingLoanDCR() {
    return this.eapplyBancaHousingLoanDCR.dcrContent.root.name_value_pair;
  }
  // public geteapplyTrackVerbiageDCR() {
  //   return this.eapplyTrackVerbiageDCR.dcrContent.TUResponseMaster.Response;
  // }
  public getaddOnGenderDCR() {
    return this.addOnGenderDCR.dcrContent.root.name_value_pair;
  }
  public getaddOnRelationshipDCR() {
    return this.addOnRelationshipDCR.dcrContent.root.name_value_pair;
  }
}
